module.exports = __webpack_public_path__ + "static/posthuman1-b51f45aaee2c8570ddbacb0c88b902af.jpg";